import { render, staticRenderFns } from "./CompetitionsTabInvitation.vue?vue&type=template&id=3534d350&"
import script from "./CompetitionsTabInvitation.vue?vue&type=script&lang=js&"
export * from "./CompetitionsTabInvitation.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsTabInvitation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports